import { Badge, Button, Divider, Stack } from "@mantine/core";
import moment from "moment";
import { useState } from "react";

export const InstallmentsModal = ({ isInstallmentDetailsModal, onClose }) => {
    const [installmentSelected, setInstallmentSelected] = useState(null);
    const total_cycles = isInstallmentDetailsModal[0].total_cycles;
    const total_paid = isInstallmentDetailsModal.filter(
        (item) => item.state === "PAID"
    )?.length;
    const total_pending = isInstallmentDetailsModal.filter(
        (item) => item.state !== "PAID"
    )?.length;

    return (
        <Stack gap={0}>
            <h4 style={{ fontSize: "var(--fs-h3)", textAlign: "center" }}>
                Detalle de cuotas
            </h4>
            <Stack gap={8} mt={8}>
                <Badge>Total de cuotas: {total_cycles}</Badge>
                <Badge color="green">Pagadas: {total_paid}</Badge>
                <Badge color="red">Pendientes: {total_pending}</Badge>
            </Stack>
            <hr style={{ border: "1px solid #0000000b" }} />
            <div
                style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "wrap",
                    width: "100%",
                }}
            >
                {Array.from({
                    length: isInstallmentDetailsModal[0].total_cycles,
                }).map((_, index) => {
                    const installment = isInstallmentDetailsModal.find(
                        (inst) => inst.cycle === index + 1
                    );

                    if (!installment) return;

                    const isPaid = installment?.state === "PAID";
                    const isSelected = installmentSelected?._id === installment?._id

                    return (
                        <div
                            onClick={() => {
                                if (isSelected) {
                                    return setInstallmentSelected(null);
                                }
                                setInstallmentSelected(installment);
                            }}
                            key={index}
                            style={{
                                cursor: "pointer",
                                width: "30px",
                                height: "30px",
                                borderRadius: "3px",
                                border: isSelected ? "1px solid #000" : "",
                                backgroundColor: isSelected
                                    ? "#fff"
                                    : isPaid
                                        ? "#4caf50"
                                        : "#fb8f8fff",
                                color: isSelected ? "#000" : "#fff",
                                fontSize: "10px",
                                display: "grid",
                                placeItems: "center",
                            }}
                        >
                            {installment.cycle}
                        </div>
                    );
                })}
            </div>

            {installmentSelected ? (
                <Stack
                    mt={8}
                    fz="var(--fs-small)"
                    c="var(--color-text-primary)"
                    fw={400}
                    gap={4}
                    style={{
                        border: "1px solid #0000006a",
                        borderRadius: "8px",
                    }}
                    p={4}
                >
                    <p>Orden de cuota: {installmentSelected.cycle}</p>
                    <p>
                        Fecha:{" "}
                        {moment(installmentSelected.date).format("DD/MM/YYYY")}
                    </p>
                    <p>
                        Estado:{" "}
                        {installmentSelected.state === "PAID"
                            ? "Pagada"
                            : "Pendiente"}
                    </p>
                    <p>
                        Monto: {installmentSelected.amount}{" "}
                        {installmentSelected?.currency}
                    </p>
                    <p>ID Cuota: {installmentSelected._id}</p>

                    {installmentSelected?.cycle_receipt &&
                       <>
                        <Divider label='Comprobante de pago'/>
                        <a href={installmentSelected.cycle_receipt} target="_blank">
                                <img src={installmentSelected.cycle_receipt} alt='Comprobante de pago'
                                    style={{
                                        height: 250,
                                        width: 'auto',
                                        objectFit: 'contain'
                                    }}
                                />
                            </a>
                       </>
                    }
                </Stack>
            ) : (
                <p style={{ marginTop: ".7rem" }}>
                    Haz click en una cuota para mas información
                </p>
            )}

            <Button type="button" mt={24} onClick={onClose}>
                Cerrar
            </Button>
        </Stack>
    );
};
